"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Story = void 0;
var common_1 = require("../common");
var ChanceCase = require("change-case");
var utils_1 = require("../../utils");
var Story = /** @class */ (function (_super) {
    __extends(Story, _super);
    function Story() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Story.defaultProps = function (name, type, user$, dog$, parent$) {
        if (parent$ === void 0) { parent$ = null; }
        return {
            id: ChanceCase.constantCase(name),
            // Story Base Info
            user$: user$,
            dog$: dog$,
            parent$: parent$,
            solutionConfirmed: false,
            created: new Date().toISOString(),
            completed: null,
            start: null,
            end: null,
            requiredDogFields: [],
            /**
             * The type this story is classified as, the ui will chain it to the parent
             * e.g. "health//nutrition"
             */
            type: type,
            types: utils_1.TypeMapper.parentRelations(type, 'story', true),
            // Story Content
            name: name,
            description: '',
            hero: null,
            memories: [],
            // Wellbeing Profile
            /**
             * To track the the stories wellbeing tracking
             * @TODO should this be in a seperate document?
             */
            targets: {}
        };
    };
    Story.firebaseTable = 'scout9-stories';
    return Story;
}(common_1.AbstractModel));
exports.Story = Story;
